import { render, staticRenderFns } from "./CoinAdminReview.vue?vue&type=template&id=2093b15b&"
import script from "./CoinAdminReview.vue?vue&type=script&lang=js&"
export * from "./CoinAdminReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports